import { render, staticRenderFns } from "./TestDetails.vue?vue&type=template&id=c9c6f07c&scoped=true"
import script from "./TestDetails.vue?vue&type=script&lang=js"
export * from "./TestDetails.vue?vue&type=script&lang=js"
import style0 from "./TestDetails.vue?vue&type=style&index=0&id=c9c6f07c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9c6f07c",
  null
  
)

export default component.exports